import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    ChartOptions,
    ChartData,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const NewDoughnutChart = ({
    dataArrLive,
    chartChannel,
    getRandomColor

}) => {

    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});



    useEffect(() => {


        const availableChannels = dataArrLive?.filter(
            (data, index) => data.data.slice(-1)[0] !== null
        );

        const availableChannelsNames = availableChannels?.map((data) => data.label);

        let lastValues = [];

        if (availableChannelsNames?.length > 0) {
            availableChannelsNames.forEach((data) => {
                if (availableChannels?.length > 0) {
                    lastValues = availableChannels?.map(
                        (chart, index) => chart?.data.slice(-1)[0]
                    );
                }
            });
        } else {
            lastValues = [50, 50];
        }

        const matchedPairs = [];
        chartChannel?.forEach((label) => {
            const matchedObj = dataArrLive.find((data) => data.label === label);
            if (matchedObj) {
                matchedPairs.push(matchedObj);
            }
        });

        let channelsLastValues;
        channelsLastValues =
            matchedPairs?.length > 0
                ? matchedPairs?.map((chart) => chart?.data.slice(-1)[0])
                : lastValues;



        const values = channelsLastValues;
        const labels = chartChannel?.length > 0
            ? chartChannel
            : availableChannelsNames.length > 0
                ? availableChannelsNames
                : ["channel1", "channel2"];

        const total = values.reduce((a, b) => a + b, 0);




        const backgroundColors = dataArrLive.length > 0
            ? dataArrLive.map(() => getRandomColor())
            : ["#00e4ec", "#501754"]




        const data = {
            labels,
            datasets: [
                {
                    data: values,
                    backgroundColor: backgroundColors,
                    borderWidth: 0,
                    cutout: '70%',
                },
            ],
        };

        const options = {
            plugins: {
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            const val = context.raw;
                            const label = context.label;
                            return `${label}: ${val.toFixed(2)} kW`;
                        },
                        // Optional: removes the leading color square from tooltip text
                        labelColor: function () {
                            return false;
                        }
                    },
                },
                legend: {
                    display: false,
                },
            },
            maintainAspectRatio: false,
        };

        setChartData(data);
        setChartOptions(options);




    }, [chartChannel, dataArrLive])


    return (
        <div style={{ width: "100%", height: "100%" }}>
            {Object.keys(chartData).length > 0 ? (
                <Doughnut
                    data={chartData}
                    options={chartOptions}
                    plugins={[{
                        id: 'centerText',
                        beforeDraw(chart) {
                            const { width, height, ctx } = chart;
                            const total = chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                            ctx.save();
                            ctx.font = 'bold 18px sans-serif';
                            ctx.fillStyle = '#333';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';
                            ctx.fillText(`${total}`, width / 2, height / 2);
                            ctx.restore();
                        }
                    }]}
                />
            ) : (
                <p>Loading Chart Data</p>
            )}
        </div>
    );
};


const DoughnutChart = ({
    dataArrLive,
    chartChannel,
    getRandomColor
}) => {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    
    useEffect(() => {
        

        const availableChannels = dataArrLive?.filter(
            (data, index) => data.data.slice(-1)[0] !== null
        );

        const availableChannelsNames = availableChannels?.map((data) => data.label);

        let lastValues = [];

        if (availableChannelsNames?.length > 0) {
            availableChannelsNames.forEach((data) => {
                if (availableChannels?.length > 0) {
                    lastValues = availableChannels?.map(
                        (chart, index) => chart?.data.slice(-1)[0]
                    );
                }
            });
        } else {
            lastValues = [50, 50];
        }

        const matchedPairs = [];
        chartChannel?.forEach((label) => {
            const matchedObj = dataArrLive.find((data) => data.label === label);
            if (matchedObj) {
                matchedPairs.push(matchedObj);
            }
        });

        let channelsLastValues;
        channelsLastValues =
            matchedPairs?.length > 0
                ? matchedPairs?.map((chart) => chart?.data.slice(-1)[0])
                : lastValues;



        const values = channelsLastValues;
        const labels = chartChannel?.length > 0
            ? chartChannel
            : availableChannelsNames.length > 0
                ? availableChannelsNames
                : ["channel1", "channel2"];

        const total = values.reduce((a, b) => a + b, 0);



        const backgroundColors = dataArrLive.length > 0
            ? dataArrLive.map(() => getRandomColor())
            : ["#00e4ec", "#501754"]




        const data = {
            labels,
            datasets: [
                {
                    data: values,
                    backgroundColor: backgroundColors,
                    borderWidth: 0,
                    cutout: '70%',
                },
            ],
        };

        const options = {
            plugins: {
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            const val = context?.raw;
                            const label = context?.label;
                            return `${label}: ${val.toFixed(2)}`;
                        },
                        // Optional: removes the leading color square from tooltip text
                        labelColor: function () {
                            return false;
                        }
                    },
                },
                legend: {
                    display: false,
                },
            },
            maintainAspectRatio: false,
        };

        setChartData(data);
        setChartOptions(options);




    }, [chartChannel, dataArrLive])

    return (

        <div style={{ width: "100%", height: "100%" }}>
            {Object.keys(chartData).length > 0 ? (
                <Doughnut
                    data={chartData}
                    options={chartOptions}
                    plugins={[{
                        id: 'centerText',
                        beforeDraw(chart) {
                            const { width, height, ctx } = chart;
                            const total = chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                            ctx.save();
                            ctx.font = 'bold 18px sans-serif';
                            ctx.fillStyle = '#333';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';
                            ctx.fillText(`${total.toFixed(2)} kW`, width / 2, height / 2);
                            ctx.restore();
                        }
                    }]}
                />
            ) : (
                <p>Loading Chart Data</p>
            )}
        </div>
    );
}

export { NewDoughnutChart, DoughnutChart }; 